import React from 'react';
import { Field } from 'redux-form';
import {
  renderTextField,
  requiredValidator,
  renderDatePicker,
  renderReferralSelect,
  renderSelect
} from 'utils/formHelper';

export default class LoanDetails extends React.Component {
  render = () => {
    return (
      <div>
        <div className='form-row' >
          <Field
            name='amount'
            component={renderTextField}
            label='Amount'
            validate={requiredValidator}
          />
          <Field
            name='termLength'
            component={renderTextField}
            label='Term Duration'
            validate={requiredValidator}
          />
          <Field
            name='termUnit'
            options={['month', 'week']}
            component={renderSelect}
            label='Term Unit'
            validate={requiredValidator}
          />
          <Field
            name='drawdownDate'
            component={renderDatePicker}
            label='Drawdown Date'
            validate={requiredValidator}
          />
          <Field
            name='purpose'
            options={['Hire Staff', 'Working Capital', 'Marketing Campaign', 'Expand Premises', 'GST Payment', 'Payroll Tax Payment', 'Tax Payment', 'Purchase Equipment', 'Debt Consolidation', 'Payment of Existing Arrears', 'Other']}
            component={renderSelect}
            label="What's the loan for"
            validate={requiredValidator}
          />
          <Field
            name='frequency'
            component={renderSelect}
            label='Repayment Frequency'
            options={['week', 'month']}
            validate={requiredValidator}
          />
          <Field
            name='contactNumber'
            component={renderTextField}
            label='Mobile Number'
            validate={requiredValidator}
          />
          <Field
            name='contactEmail'
            component={renderTextField}
            label='Email'
            validate={requiredValidator}
          />
          <Field
            name='frequency'
            component={renderReferralSelect}
            label='Referral'
            options={this.props.referrals}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Applications/LoanDetails.js